<template>
    <div class="staff-group-select">
        <staff-select-dialog
            v-if="firstOpen"
            ref="mlist"
            v-model="openMultiple"
            :selected="staffSelected"
            :init="false"
            :depart-can-select="true"
            :his-selected="staffSelected"
            :title-selected="$t('已选员工/部门')"
            :subtitle="$t('选择监控对象')"
            @select="showSelect"
        />
        <div>
            <div
                id="staff-select-title"
                class="group-form__title"
            >
                <!-- <span>监控对象</span> -->
                <!-- <span
                    v-if="staffSelected.length || propStaffOrgList.length > 0"
                    class="select-btn select-btn-title"
                    @click="changeSelect"
                >修改
                </span> -->
                <v-button
                    v-if="staffSelected.length || propStaffOrgList.length > 0"
                    type="link"
                    kind="primary"
                    @click="changeSelect"
                >
                    <v-icon remote name="basic_new_line" />
                    {{ $t('添加员工') }}
                </v-button>
                <!-- <span :class="staffSelectedErr ? 'save-error' : 'error-hidden'">请选择</span> -->
            </div>
            <span
                v-if="staffSelected.length == 0 && propStaffOrgList.length == 0"
                class="select-btn"
                @click="
                    openMultiple = true;
                    firstOpen = true;
                    $emit('changeSelected',false);
                "
            >{{ $t(currentText) }}</span>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { Popconfirm, SelectList, Checkbox, Icon, Spinner, OnScrollto } from 'vhtml-ui';
import HighlightText from '@/components/highlight-text';
import StaffSelectDialog from './staff-select-dialog';

// const sprites = require.context('./assets/icons', true, /[^\.]+\.svg$/)
// Icon.addSprites(sprites)

const GROUP_API_URL = '/tp/IMAccessSet/getList';
// const GROUP_API_URL = '/tp/rest/IMAccessSet'
const GROUP_SINGLE_API_URL = '/tp/IMAccessSet/single';
const STAFF_API_URL = '/mng/org/getUserTreeNodes';
function R3() {
    return Math.random()
        .toString()
        .substring(2, 5);
}
export default {
    name: 'StaffSelect',

    components: {
        VPopconfirm: Popconfirm,
        VSelectList: SelectList,
        VCheckbox: Checkbox,
        VIcon: Icon,
        VSpinner: Spinner,
        VHighlightText: HighlightText,
        StaffSelectDialog
    },

    props: {
        groupUrl: {
            type: String,
            default: GROUP_API_URL
        },
        groupSingleUrl: {
            type: String,
            default: GROUP_SINGLE_API_URL
        },
        staffUrl: {
            type: String,
            default: STAFF_API_URL
        },
        extraParams: {
            type: Object,
            default() {
                return {
                    // privileges: [22]
                };
            }
        },
        propStaffSelected: {
            tyoe: Array,
            default() {
                return [];
            }
        },
        propStaffOrgList: {
            tyoe: Array,
            default() {
                return [];
            }
        },
        deleteIds: {
            type: Array,
            default() {
                return [];
            }
        },
        staffSelectedErr: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },

    data() {
        const staffSelected = []; // 在外层已经控制不重复
        const orgSelectList = [];
        this.propStaffSelected.forEach(staff => {
            staffSelected.push({
                id: staff.id? staff.id : "",
                name: staff.name? staff.name : "",
                ename: staff.ename? staff.ename : "",
                gender: staff.gender
            });
        });

        return {
            hasInit: false,
            open: false, // 控制选择员工/部门弹窗的显隐
            openMultiple: false,
            firstOpen: false,

            visible: false,

            isSearch: false,

            currentText: this.$t('添加员工'),

            staffListIndex: 0,
            staffListCount: 50,
            staffList: [],

            staffListFetching: false,
            staffListMoreLoading: false,
            noMoreStaffList: false,

            staffIndex: 0,
            staffCount: 10,
            staffs: [],

            globalLoading: true,

            staffFetching: false,
            staffMoreLoading: false,

            noMoreStaff: false,

            staffKeyword: '',
            staffSelected,
            orgSelectList,
            existedStaff: []
        };
    },

    computed: {
        confirmText() {
            return this.staffSelected.length === 0 ? this.$t('确定') : this.$t('确定({n})', { n: this.staffSelected.length });
        },

        disabled() {
            return this.staffSelected.length === 0;
        }
    },

    watch: {
        propStaffSelected(newVal) {},
        deleteIds(newVal) {
            newVal.forEach(id => {
                this.selectStaff(false, { id }, 'list');
            });
            this.checkSelectedStaff();
        },
        visb(newVal) {
            this.visible = newVal;
            console.log(newVal);
        }
    },

    methods: {
        changeSelect() {
            this.openMultiple = true;
            this.firstOpen = true;
            let addOrgId = [];
            console.log(this.propStaffSelected,'我传的',this.propStaffOrgList);
            this.propStaffOrgList.forEach(item=>{
                addOrgId.push({
                    id: item.id,
                    name: item.name,
                    isFolder: true,
                    total: item.total
                })
            })
            this.staffSelected = addOrgId.concat(this.propStaffSelected);
            console.log(this.staffSelected,'合并的');
            this.$emit('changeSelected',false);
        },
        getTreeDataDetail() {
            if (this.staffListFetching) return;
            this.staffListFetching = true;

            const done = () => {
                this.globalLoading = false;
                this.staffListFetching = false;
                this.staffListMoreLoading = false;
            };
            const traceid = (function() {
                return R3() + R3() + R3();
            })();
            const defer = this.$ajax.post('/mng/org/getUserTreeNodes', {
                // owner: 2852821311,
                // privileges: [22],
                current_page: this.staffListIndex,
                items_per_page: this.staffListCount,
                traceid
                // _bqq_csrf: cookie.get("_bqq_csrf")
            });
            defer.catch(res => {
                this.$message.error(res.message || this.$t('获取数据失败'));
            });
            defer.then(data => {
                // let staffList = data.list || [];
                // staffList.forEach(staff => {
                //   staff.check = false;
                // });
                data.list.forEach(item => {
                    if (!this.existedStaff.includes(item.id)) {
                        this.existedStaff.push(item.id);
                        item.check = this.includesItem(this.staffSelected, 'id', item);
                        this.staffList.push(item);
                    }
                });

                if (data.list.length < this.staffListCount) {
                    this.noMoreStaffList = true;
                }

                // this.staffList.push(...staffList);
                // this.checkSelectedStaff();
                done();
            });
        },
        initData() {
            this.getTreeDataDetail();
        },
        // 更具staff.id检查并赋值.check
        checkSelectedStaff() {
            const arrs = [this.staffList, this.staffs];
            arrs.forEach(arr => {
                arr.forEach(staff => {
                    staff.check = this.includesItem(this.staffSelected, 'id', staff);
                });
            });
        },
        includesItem(itemList, key, item) {
            let i;
            for (i = 0; i < itemList.length; i++) {
                if (itemList[i][key] == item[key]) return true;
            }
            return false;
        },
        refreshStaffList() {
            this.globalLoading = true;
            this.getTreeDataDetail();
        },

        moreStaffList() {
            if (this.noMoreStaffList || this.staffListFetching) {
                return;
            }

            this.staffListMoreLoading = true;
            this.staffListIndex++;
            this.getTreeDataDetail();
        },

        searchStaff() {
            this.$refs.content && (this.$refs.content.scrollTop = 0);
            this.isSearch = this.staffKeyword !== '';

            if (this.isSearch) {
                this.globalLoading = true;
                this.staffs = [];
                this.fetchStaff();
            } else {
                this.staffs = [];
            }
        },

        fetchStaff() {
            if (this.staffFetching) return;

            const params = {
                current_page: this.staffIndex,
                items_per_page: this.staffCount,
                keywords: this.staffKeyword
            };

            this.staffFetching = true;

            const done = () => {
                this.globalLoading = false;
                this.staffFetching = false;
                this.staffMoreLoading = false;
            };

            this.$ajax
                .post('/mng/org/getUserTreeNodes', params)
                .then(res => {
                    let staffs = res.list || [];
                    const { total } = res;
                    if (staffs.length < this.staffCount && total === this.staffs.length + staffs.length) {
                        this.noMoreStaff = true;
                    }
                    staffs = this.parseStaff(staffs);
                    this.staffs.push(...staffs);
                    done();
                })
                .catch(done);
        },

        moreStaff() {
            if (this.noMoreStaff || this.staffFetching) {
                return;
            }

            this.staffIndex++;
            this.staffMoreLoading = true;
            this.fetchStaff();
        },

        parseStaff(staffs) {
            return staffs.map(staff => {
                const ret = {
                    id: +staff.id,
                    ename: staff.ename,
                    cname: staff.cname,
                    check: this.includesItem(this.staffSelected, 'id', staff)
                };

                // if (this.staffSelected.includes(ret.id)) {
                //   ret.check = true;
                // }

                return ret;
            });
        },

        checkStaff(staff, type) {
            // console.log(staff.check);
            this.selectStaff(staff.check, staff, type);
            // 因为在增加数据时已经增加了去重，所以此处不需要多余处理
        },

        selectStaff(check, staff, type, group) {
            if (check) {
                if (!this.includesItem(this.staffSelected, 'id', staff)) {
                    this.staffSelected.push(staff);
                }
            } else if (type === 'search' || type === 'list') {
                this.staffSelected = this.staffSelected.filter(selected => {
                    return selected.id != staff.id;
                });
            }
        },

        handleScrollBottom() {
            this.isSearch ? this.moreStaff() : this.moreStaffList();
        },

        handleVisible(visible) {
            // console.log("visible change", visible);
            if (visible && !this.hasInit) {
                this.hasInit = true;
                this.initData();
            }
        },

        handleAll() {
            // 全选只有在非搜索时存在，所以不需要对this.staffs处理
            this.staffList.forEach(staff => {
                if (!staff.check) {
                    staff.check = true;
                    this.staffSelected.push(staff);
                }
            });
        },

        handleClear() {
            // 清除只有在非搜索时存在，所以不需要对this.staffs处理
            this.staffList.forEach(staff => {
                if (staff.check) {
                    staff.check = false;
                    this.selectStaff(false, staff, 'list');
                }
            });
        },

        handleConfirm() {
            const emitData = [];
            this.staffSelected.forEach(staff => {
                emitData.push({
                    id: staff.id,
                    cname: staff.cname,
                    ename: staff.ename
                });
            });
            this.$emit('change', emitData);

            this.visible = false;
        },

        handleCancel() {
            // 取消操作，将选择的员工恢复到上次确认选择的状态
            const staffSelected = [];
            this.propStaffSelected.forEach(staff => {
                staffSelected.push({
                    id: staff.id,
                    cname: staff.cname,
                    ename: staff.ename
                });
            });
            this.staffSelected = staffSelected;
            this.checkSelectedStaff();
            this.visible = false;
        },
        showSelect(res) {
            //  let userList = [];
            //  let depart = [];
            //        let staffList = res.map(item=>{
            //      if(item.isFolder==false) {
            //          userList.push(item)
            //          return userList
            //      }
            //  })
            //     console.log(userList,'员工')
            //  let staffOrgList = res.map(item=>{
            //       if(item.isFolder==true) {
            //          depart.push(item)
            //          return depart
            //      }
            //  })
            // this.staffSelected = userList;
            // this.orgSelectList = depart;
            this.staffSelected = res;
            console.log(this.staffSelected,res)

            console.log('我是传归来的res',res);
            this.$emit('select', res);
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common';

.staff-group-select-popup {
    .v-popconfirm__button {
        min-width: 80px;
        height: 40px;
    }
}

.staff-group-select {
    display: inline-block;
    // width: 200px;
    // min-height: 30px;
    color: #1e2330;
    box-sizing: border-box;

    .select-btn {
        color: @mainBlue;
        cursor: pointer;

        &:hover {
            color: #005cd4;
        }
    }

    .select-btn-title {
        margin-left: 10px;
        font-size: 14px;
        line-height: 20px;
    }

    #staff-select-title {
        // padding-bottom: 10px;
    }

    &-header {
        position: relative;
        overflow: hidden;
        overflow: hidden;
        padding: 0 10px 0 12px;
        min-width: 50px;
        font-size: 14px;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        background-color: #fff;
        border: 1px solid #dadee7;
        border-radius: 2px;
        transition: border-color 0.25s, background-color 0.25s;
        line-height: 38px;
        cursor: pointer;

        &:hover {
            border-color: #a8abb3;
        }

        &:active {
            background-color: #ebedf2;
            border-color: #a8abb3;
        }

        &-arrow {
            &.v-icon {
                position: absolute;
                top: 15px;
                right: 10px;
                width: 10px;
                height: 10px;
                cursor: pointer;
                stroke: #a8abb3;
            }
        }
    }

    &-popup {
        margin-top: 5px;
        // &:before {
        //   content: '';
        //   position: fixed;
        //   left: 0;
        //   right: 0;
        //   top: 0;
        //   bottom: 0;
        //   z-index: -1;
        // }
        .staff-search-input {
            width: 100%;
            margin-bottom: 10px;
        }
    }

    &-container {
        width: 310px;
        height: 320px;
        border: 1px solid #dadee7;
    }

    &-content {
        overflow-y: auto;
        height: 320px;
    }

    &-list {
        .group-item,
        .staff-item {
            &__title {
                position: relative;
                overflow: hidden;
                padding: 8px 12px;
                height: 20px;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 20px;

                .v-checkbox {
                    // margin-left: 20px;
                }

                .v-checkbox__label {
                    display: inline-block;
                    overflow: hidden;
                    margin-left: 10px;
                    width: 225px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                &:hover {
                    background-color: #f5fafe;
                }
            }

            &__arrow {
                position: absolute;
                top: 8px;
                left: 10px;
                width: 20px;
                height: 20px;
                line-height: 0;
                cursor: pointer;

                .icon-arrow {
                    position: absolute;
                    top: 6px;
                    left: 9px;
                    width: 0;
                    height: 0;
                    background: none;
                    border-left: 4px solid #66686c;
                    border-right: 4px solid transparent;
                    border-top: 4px solid transparent;
                    border-bottom: 4px solid transparent;
                }

                &--unfold {
                    .icon-arrow {
                        top: 8px;
                        left: 6px;
                        border-top: 4px solid #66686c;
                        border-right: 4px solid transparent;
                        border-left: 4px solid transparent;
                        border-bottom: 4px solid transparent;
                    }
                }

                &--loading {
                    .icon-arrow {
                        top: -1px;
                        left: 0;
                        width: 20px;
                        height: 20px;
                        background: url(data:image/gif;base64,R0lGODlhEAAQAPIAAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAEADMmi6RbWwPRjdAgFQuS3nEKZ9lgJSZmmc6YSu6rsQAyEbgRBQtH3fPWDtJ/TNhrIgkZgAACH5BAUKAAYALAIAAAAHAAUAQAMPaGoQUKQsA2UDM4hABpkJACH5BAUKAAYALAYAAAAHAAUAQAMOWFTW3iAAxSIgg7wXREgAIfkEBQoABgAsCgACAAUABwBAAw9YVNYGASjmICCDuN2CCAkAIfkEBQoABgAsCgAGAAUABwBAAxBoVlQQQCnmoDRkkGuCCEoCACH5BAUKAAYALAYACgAHAAUAQAMPaGpFBQEsA2UrkwwSRJgJACH5BAUKAAYALAIACgAHAAUAQAMOCAHW3oUUxWIJIrxHBkkAIfkEBQoABgAsAAAGAAUABwBAAw8IAdZWpCjmYAkiuN3IIAkAOw==);
                        border: none;
                    }
                }
            }
        }

        .staff-item {
            &__title {
                .v-checkbox {
                    margin-left: 0;
                }

                .v-checkbox__label {
                    margin-left: 10px;
                }

                .v-checkbox__label {
                    div {
                        display: inline;
                    }
                }
            }
        }

        .group-sub-item {
            padding: 8px 12px 8px 60px;
            height: 20px;
            line-height: 20px;

            .v-checkbox__label {
                display: inline-block;
                overflow: hidden;
                width: 180px;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            &:hover {
                background-color: #f5fafe;
            }
        }

        &-more {
            padding: 5px 0;
            text-align: center;
        }

        &-empty {
            position: absolute;
            top: 50%;
            left: 50%;
            text-align: center;
            transform: translate(-50%, -50%);

            h5 {
                font-size: 16px;
            }

            a {
                display: block;
                line-height: 30px;
            }

            &__refresh {
                margin-top: 10px;
                color: #a8abb3;

                &:hover {
                    color: #66686c;
                }
            }
        }
    }

    &-option {
        float: left;
        line-height: 40px;

        a {
            margin-right: 10px;
        }
    }
}
</style>
